<template>
    <SliceZone :components="components" :slices="article?.data?.slices" />
</template>

<script lang="ts" setup>
    import {ref, inject} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import {PRISMIC_DOCUMENT} from '~/app/keys';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {components} from '~/slices/components';
    const document = inject(PRISMIC_DOCUMENT, ref());

    const {data: article} = await useAsyncData('homepage', () => usePrismicDocument('resourcesCenterHome'), {deep: true});
    document.value = article.value;

    useWebsitePageView('resources-center', 'homepage');
</script>
